
// panel-item script -----------------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {

function fullSelectScript(){
  const panels = document.querySelectorAll('.panel-item');
  const subtotalEl = document.getElementById('subtotal_ongoing_cost');

  function getSubtotal() {
    return parseFloat(subtotalEl.textContent) || 0;
  }

  function setSubtotal(value) {
    // Ongoing subtotal
    subtotalEl.textContent = Math.max(0, value).toFixed(0);

    // Base / default cost
    const baseCostEl = document.querySelector('.total_cost');
    const baseCostDefault =
      parseFloat(baseCostEl.getAttribute('default-value')) || 0;

    // Final total = default base + calculated value
    const finalTotal = baseCostDefault + Math.max(0, value);
    baseCostEl.textContent = finalTotal.toFixed(0);
  }

  panels.forEach(panel => {
    const checkbox = panel.querySelector('.item-checkbox');
    const priceEl = panel.querySelector('.item-price');
    const monthEl = panel.querySelector('.item-month');

    function getItemValue() {
      const price = parseFloat(priceEl.value) || 0;
      const months = parseFloat(monthEl.value) || 0;
      return price * months;
    }

    // ADD / SUBTRACT on checkbox
    checkbox.addEventListener('change', () => {
      if (checkbox.type === 'radio') return;

      let subtotal = getSubtotal();
      let prevValue = parseFloat(panel.dataset.prevValue) || 0;

      if (checkbox.checked) {
        // Only calculate if not already added
        if (prevValue === 0) {
          prevValue = getItemValue();
          panel.dataset.prevValue = prevValue;
          subtotal += prevValue;
        }
      } else {
        subtotal -= prevValue;
        panel.dataset.prevValue = 0;
      }

      setSubtotal(subtotal);
    });




// ADD / SUBTRACT on radio change
function handleRadioChangeSimple(radio) {
  const prevHolder = document.getElementById('radio-prev-value');

  let subtotal = getSubtotal();

  // subtract previously stored value (ONLY from holder)
  const prevValue = parseFloat(prevHolder.dataset.value) || 0;
  subtotal -= prevValue;

  // calculate new value
  let newValue = 0;
  const panel = radio.closest('.panel-item');

  if (panel) {
    const price = parseFloat(panel.querySelector('.item-price')?.value || 0);
    const months = parseFloat(panel.querySelector('.item-month')?.value || 0);
    newValue = price * months;
  }

  // add new value
  subtotal += newValue;

  // store ONLY here (single source)
  prevHolder.dataset.value = newValue;

  setSubtotal(subtotal);
}


document
  .querySelectorAll('input[type="radio"][name="Childcare"]')
  .forEach(radio => {
    radio.addEventListener('change', function () {
      handleRadioChangeSimple(this);
    });
  });





    // Helper: bind events for select / input
    function bindChangeEvents(el) {
      if (!el) return;

      const events =
        el.tagName === 'SELECT' || el.type === 'hidden'
          ? ['change']
          : ['input', 'change'];

      events.forEach(evt => {
        el.addEventListener(evt, () => {
          if (!checkbox.checked) return;
          if (checkbox.type === 'radio') return handleRadioChangeSimple(checkbox);

          let subtotal = getSubtotal();
          const oldValue = parseFloat(panel.dataset.prevValue) || 0;
          const newValue = getItemValue();

          subtotal = subtotal - oldValue + newValue;
          panel.dataset.prevValue = newValue;

          setSubtotal(subtotal);
        });
      });
    }

    // Recalculate on price OR month change
    bindChangeEvents(priceEl);
    bindChangeEvents(monthEl);

      // ---------- INITIALIZE PRE-CHECKED CHECKBOXES ----------
        document
          .querySelectorAll('.item-checkbox:checked')
          .forEach(input => {
            input.dispatchEvent(new Event('change'));
          });

        // ---------- INITIALIZE PRE-SELECTED RADIO ----------
        const checkedRadio = document.querySelector(
          'input[type="radio"][name="Childcare"]:checked'
        );

        if (checkedRadio) {
          handleRadioChangeSimple(checkedRadio);
        }



  });



}

fullSelectScript();




// select box updating ------------------------------------------------------------------------------------------

const estimateSelect = document.querySelector('.estimate-select');
  const priceWrap = document.querySelector('.estimate-select-basedid');

  estimateSelect.addEventListener('change', () => {
    const selectedValue = estimateSelect.value; // e.g., "daycare", "family_daycare"

    // Find the hidden select with the matching id
    const hiddenSelect = document.getElementById(selectedValue);
    if (!hiddenSelect) return;

    // Remove existing item-price select inside priceWrap
    const currentSelect = priceWrap.querySelector('.item-price');
    if (currentSelect) currentSelect.remove();

    // Clone the hidden select
    const newSelect = hiddenSelect.cloneNode(true);
    newSelect.style.display = 'block'; // make it visible
    newSelect.classList.add('item-price'); // keep class if needed

    // Append to the priceWrap
    priceWrap.appendChild(newSelect);
    fullSelectScript();

    // FORCE first-time calculation
    newSelect.dispatchEvent(new Event('change', { bubbles: true }));

  });

  // Trigger change on page load to show default
  estimateSelect.dispatchEvent(new Event('change'));




















// end
  });